export enum OfferUserStatusEnum {
  New = 1,
  Pending,
  Disabled,
  Active,
  InActive,
}
